/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        document.body.innerHTML=document.body.innerHTML.replace(/\u00AD/g, ''); // remove '&shy;' down footer arrows


        // Single post active
        function parentMenuActive() {
         
          // Default single post
          if ($('#body-tag').is('.post-template-default')) {

            if($('#body-tag').hasClass('en')){
              $('.menu-item-1083').addClass('current-menu-item');
            }
            else if($('#body-tag').hasClass('zh-hans')){
              $('.menu-item-30').addClass('current-menu-item');
            }
          
          // Single career page
          } else  if ($('#body-tag').is('.careers_register-template-default')) {

            if($('#body-tag').hasClass('en')){
              $('.menu-item-1084').addClass('current-menu-item');
            }
            else if($('#body-tag').hasClass('zh-hans')){
              $('.menu-item-29').addClass('current-menu-item');
            }

          // Single team member profile
          } else if ($('#body-tag').is('.team_member_register-template')) {

            if($('#body-tag').hasClass('en')){
              $('.menu-item-1072').addClass('current-menu-item');
            }
            else if($('#body-tag').hasClass('zh-hans')){
              $('.menu-item-31').addClass('current-menu-item');
            }

          } else if ($('#body-tag').is('.search')) {

            if($('#body-tag').hasClass('en')){
              $('.menu-item-1083').addClass('current-menu-item');
            }
            else if($('#body-tag').hasClass('zh-hans')){
              $('.menu-item-30').addClass('current-menu-item');
            }

          } else {

          }


        }
        //refreash();

        // Menu functions
        function menuShrink() {
          var baseUrl = document.location.origin;
      
          $(window).scroll(function() {
            if ($(document).scrollTop() > 50) {
                $('header.header').addClass('shrink');
                $('a.brand').addClass('colour');
            } else {
                $('header.header').removeClass('shrink');
                $('a.brand').removeClass('colour');
            }
          });
        }
        //menuShrink();
        

        function menuHighlight() {

            var $el, leftPos, newWidth,
            $mainNav = $("nav.nav-primary ul.nav");
        
            //$mainNav.append("<li id='magic-line'></li>");
            var $magicLine = $("#marker");
            
            // Active page line
            if($('nav.nav-primary ul.nav > .current-menu-item').length) {
                $magicLine
                .width($("nav.nav-primary ul.nav > .current-menu-item").width())
                .css("left", $("nav.nav-primary ul.nav > .current-menu-item a").position().left)
                .data("origLeft", $magicLine.position().left)
                .data("origWidth", $magicLine.width());

            } else if ($('nav.nav-primary .current-page-ancestor').length) {
                $magicLine
                .width($(".current-page-ancestor").width())
                .css("left", $(".current-page-ancestor a").position().left)
                .data("origLeft", $magicLine.position().left)
                .data("origWidth", $magicLine.width());
            } else {

            }
            
            // Line movements
            $("nav.nav-primary ul.nav > li > a").hover(function() {
                $el = $(this);
                leftPos = $el.position().left;
                newWidth = $el.parent().width();
                $magicLine.stop().animate({
                    left: leftPos,
                    width: newWidth
                }, 200);


            // Make the line stay on the parent when hover on the subpages.
                $("nav.nav-primary .menu-item-has-children, nav.nav-primary .sub-menu-wrap").hover(function() {
                  if( !$('#body-tag').is('.parent-pageid-15, .parent-pageid-208, .page-parent')) {
                      
                      $magicLine.stop().animate({
                          left: leftPos, 
                          width: newWidth
                      }, 200);

                  }
                });

                // Back to the active item
                $("nav.nav-primary .menu-item-has-children, nav.nav-primary .sub-menu-wrap").mouseleave(function() {


                  if(!$('nav.nav-primary ul.nav > .current-menu-item').length) {
                    if( !$('#body-tag').is('.parent-pageid-15, .parent-pageid-208, .page-parent')) {
                      $magicLine.stop().animate({
                          left: 0,
                          width: 0
                      }, 200);
                    }
                  }

                  if(!$('#body-tag').is('.parent-pageid-15, .parent-pageid-208, .page-parent')) {

                    $el = $('nav.nav-primary ul.nav > .current-menu-item a');

                    if($el.length){
                      leftPos = $el.position().left;
                      newWidth = $el.parent().width();
                      $magicLine.stop().animate({
                          left: leftPos,
                          width: newWidth
                      }, 200);
                    }
                  }
                });


            }, function() {

              if($('nav.nav-primary ul.nav > .current-menu-item, .current_page_parent, .current-page-ancestor').length) {
                $magicLine.stop().animate({
                    left: $magicLine.data("origLeft"),
                    width: $magicLine.data("origWidth")
                }, 200);

              // Make sure the line will go away when page is not on the menu
              } else {
                $magicLine.css({
                  'left':0,
                  'width':0
                });
              }
            });
        }
        //menuHighlight();

        function subNav() {
           $(".menu-item-33 a").mouseover(function() {
              
              if( !$('#body-tag').is('.parent-pageid-15, .page-parent')) {

                  $('.service-subNav').fadeIn(); //toggleClass('active');  

                  $(".menu-item-33 a").mouseleave(function() {
                    
                      $('.service-subNav').fadeOut();
                    
                  });
                  
                  $(".subNav-container").not('.menu-item-33 a').mouseleave(function () {
                      $('.service-subNav').fadeOut();
                    });

                } else {
                  $('.service-subNav').show();
                }
          });


          

          /*
          $(".menu-item-33 a").on("click", function(e){ 
              e.preventDefault();
                if( !$('#body-tag').hasClass('parent-pageid-15')) {
                  $('.service-subNav').fadeToggle();//toggleClass('active');  
                }
          });*/
        }

        //subNav();

       /* function widgetScroll() {
          $(window).scroll(function() {
            if($(window).scrollTop() + $(window).height() > $(document).height() - 400) {
                 $('.banner-widget').fadeOut(400);
             } else {
                $('.banner-widget').fadeIn(400);
             }
          });
        }
        widgetScroll();*/

        function searchBarHover() {
          $("input.search-bar").click(function(){
              $('.searchBar-line').addClass('active');
          });

          $('input.search-bar[type="text"]').val("");
                  
          $('input.search-bar').focusout(function(){
            if($(this).val() !== ""){
              $('.searchBar-line').addClass('active');
            }else{
              $('.searchBar-line').removeClass('active');
            }
          });

          $("input.search-bar").on("click","input",function(){
              if ($(this).is( ":focus" )) {
                  $('.searchBar-line').addClass('active');
              } else {
                  $('.searchBar-line').removeClass('active');
              }
          });

          $("input.search-bar").focusout(function(){
              $('.searchBar-line').removeClass('active');
          });
        }

        // Parallax
        function parallaxEff() {
          function isInViewport(node) {
              var rect = node.getBoundingClientRect();
              return (
                (rect.height > 0 || rect.width > 0) &&
                rect.bottom >= 0 &&
                rect.right >= 0 &&
                rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.left <= (window.innerWidth || document.documentElement.clientWidth)
              );
            }

            // Populate images from data attributes.
            $('.parallax').each(function(index) {
                var imageSrc = $(this).data('image-src');
                var imageHeight = $(this).data('height');
                $(this).css('background-image','url(' + imageSrc + ')');
                $(this).css('height', imageHeight);
            });

            
            
              $(window).scroll(function() {
                if ($(window).width() >= 992) {

                var scrolled = $(window).scrollTop();
                $('.parallax').each(function(index, element) {
                  var initY = $(this).offset().top;
                  var height = $(this).height();
                  var endY  = initY + $(this).height();

                  // Check if the element is in the viewport.
                  var visible = isInViewport(this);
                  if(visible) {
                    var diff = scrolled - initY;
                    var ratio = Math.round((diff / height) * 100);
                    $(this).css('background-position','center ' + parseInt(-(ratio * 1.5)) + 'px');
                  }
                });

                }
              });

        }

        //parallaxEff();

        
        //last_page = null;


    // Ajax load news

      function getURLParameter(sParam){
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) 
        {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) 
            {
                return sParameterName[1];
            }
        }
      }

      function url_filter(){
          newCategory = getURLParameter("cat");          
       
          if(typeof newCategory !== 'undefined'){

            $('.list-item').removeClass('active');
            $('.cat-name[data-slug=' + newCategory + ']').addClass('active');
            

           }else{
            newCategory = '';
            //$('#client-sector-selector').removeClass('active');
           }
      }


      function load_news_data(){
        //location.reload();

        $('.cat ul.cat-list li a').addClass('bind');
        
        //console.log("load_news_data");

        url_filter();
        
        var ajaxurl = '/wp-admin/admin-ajax.php';

        var data = {
          pageNumber: newPage,
          catergory: newCategory,
          lang: currentLang,
          action: "load-news-data"
        };
        
        
        $.post(ajaxurl, data, function(response) {
          $response = $(response);

          $response.hide();

          //console.log($response);

          $("#news-result").append($response);

          $response.fadeIn(500, function(){
            loading = false;
          });
          
          loading = false;
          
          if(last_page){
            $('.load_btn_container').hide();
            }else{
            $('.load_btn_container  a#load_btn').css('opacity',1);
          }

          $('.cat ul.cat-list li a').removeClass('bind');
        });

        
/*        

        $.ajax({
            type: 'post',
            dataType: 'html',
                url: '/wp-admin/admin-ajax.php',
                data:{
                    pageNumber: newPage,
                    catergory: newCategory,
                    lang: currentLang,
                    action: "load-news-data"
                },
                success:function(response){
                  //alert('Ajax data loaded');
                  $response = $(response);
                  $response.hide();
                  $("#news-result").append($response);
                  $response.fadeIn(500, function(){
                    loading = true;
                  });
              
                if(last_page){
                  $('.load_btn_container').hide();
                  }else{
                  $('.load_btn_container  a#load_btn').css('opacity',1);
                }

                $('.cat ul.cat-list li a').removeClass('bind');

                },
                error: function(errorThrown){
                     console.log(errorThrown);
                }
           });


*/



      }
      //load_news_data();

      function load_more_click() {
           $('#load_btn').click(function() {
            var $content = $("#news-result");
            $('.load_btn_container a#load_btn').css('opacity',0);
            var content_offset = $content.offset();
            //console.log(content_offset.top);
            
            if(($(window).scrollTop() + $(window).height()) > ($content.scrollTop() + $content.height() + content_offset.top)) {
              newPage++;
              load_news_data();
            }
            
            return false;

          });
        }
       //load_more_click();

      // Initialte the catergory click
      function initCat(){
        $('.cat-name a').each(function(){
          $(this).click(function(){
            $(this).parent().siblings().removeClass('active');
            $(this).parent().addClass('active');

            newPage = 1;

            // Get value
            newCategory = $(this).parent().attr('data-slug');
            //alert(cat_var);

            var url = full_url;
            
            if(newCategory !== ''){
              url = url + '?cat=' + newCategory;
            }

            history.pushState('','', url);
            $("#news-result").html('');

            //set_cat_fields();
            load_news_data();
          });
        });
      }
      //initCat();

        // Ajax load careers
      //var jobType_var ='';
      //var location_var ='';

      function career_getURLParameter(sParam){
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) 
        {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) 
            {
                return sParameterName[1];
            }
        }
      }

      function career_url_filter(){
       var type_url_filter = career_getURLParameter("type");
       var location_url_filter = career_getURLParameter("location");    
       
          if(typeof type_url_filter !== 'undefined'){

            jobType = type_url_filter;
            
          } else if (typeof location_url_filter !== 'undefined') { 
            
            jobLocation = location_url_filter;

          } else {

            jobType = '';
            jobLocation = '';
            
           }

      //$('html,body').animate({scrollTop: $('#jobs-result').offset().top - 600},'slow');

      }


      function load_careers_data(){
        career_url_filter();

        var ajaxurl = '/wp-admin/admin-ajax.php';

        //alert(jobType_var);

         //jobType_filter = jobType_var;
         //location_filter = location_var;
        
        // alert(jobType_filter);
        // location_filter = $('#selected-location').val();

        var data = {
          jobTypeData: jobType,
          locationData: jobLocation,
          lang: currentLang,
          action: "load-careers-data"
        };
        
        
        $.post(ajaxurl, data, function(response) {
          $response = $(response);

          $response.hide();
          $("#jobs-result").append($response);
          $('.btm-img').show();
          $response.fadeIn(500, function(){
            loading = false;
          });
          
          loading = false;
          
        });

      }
      


      // Set dropdown text
      function set_dropdown_txt(){
       
       var jobType = career_getURLParameter("type");
       var jobLocation = career_getURLParameter("location");
          
        if(typeof jobType !== 'undefined'){
          var selected_type_text = $('#job_type_selector a.dropdown-item[data-selected-type="' + jobType + '"]').text();
          $('#job_type_selector .dropdown-toggle span').text(selected_type_text);

          if($('#body-tag').hasClass('en')){
            $('#location_selector .dropdown-toggle span').text('ALL');
          }
          else if($('#body-tag').hasClass('zh-hans')){
            $('#location_selector .dropdown-toggle span').text('所有');
          }
          

       } else if (typeof jobLocation !== 'undefined') {
          var selected_location_text = $('#location_selector a.dropdown-item[data-selected-location="' + jobLocation + '"]').text();
          $('#location_selector .dropdown-toggle span').text(selected_location_text);

          if($('#body-tag').hasClass('en')){
            $('#job_type_selector .dropdown-toggle span').text('ALL');
          }
          else if($('#body-tag').hasClass('zh-hans')){
            $('#job_type_selector .dropdown-toggle span').text('所有');
          }
       }
    }
    

      // Initialte the dropdown click
      function initJobTypeSelection(){
        
      $('#job_type_selector a.dropdown-item').each(function(){
        $(this).click(function(){
          
          jobLocation = '';

          jobType = $(this).data('selected-type');

          //URL config
          var url = full_url;
          
          if(jobType !== ''){
            url = url + '?type=' + jobType;
          }
          
          history.pushState('','', url);
          $("#jobs-result").html('');
          
          set_dropdown_txt();
          load_careers_data();

        }); 
      });

      }
      

      function initLocationSelection(){

      $('#location_selector a.dropdown-item').each(function(){
        $(this).click(function(){

          jobType = '';
          
          jobLocation = $(this).data('selected-location');

          //URL config
          var url = full_url;
          
          if(jobLocation !== ''){
            url = url + '?location=' + jobLocation;
          }
          
          history.pushState('','', url);
          $("#jobs-result").html('');
          
          set_dropdown_txt();
          load_careers_data();

        }); 
      });

      }
      

      function slider() {
        if($('.hero').length) {
          $('.hero').slick({
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 600,
            //lazyLoad: 'ondemand',
            fade: true,
            cssEase: 'linear',
            autoplay: false,
            autoplaySpeed: 2500,
            dots: true,
            customPaging: function(slick,i) {
                return '<div class="hero-nav-container"><span class="hero-nav-num">' + (i + 1) + '</span><span class="hero-nav-line"></span></div>';
            },
            /*responsive: [
              {
                breakpoint: 1200,
                settings: {
                  dots: false
                }
              }
            ]*/
            });

          //$('.hero').show();
          }
        }

        //slider();


        function heroBanner() {
          if($('.hero, .header-banner, .header-banner-base').length) {
            var w_height = $( window ).height();
            var w_width = $( window ).width();
            if( w_width >= 576) {
              $('.hero, .header-banner, .header-banner-base').css('height', w_height);  
            } else {
              $('.hero').css('height', w_height);  
              $('.header-banner, .header-banner-base').css('height', 550);  
            }
            
          }
        }
        //heroBanner();

        function contentScrollingEffect() {

          var title = $('.animationWrapper');
            if( title.length > 0) {
              title.each(function() {
                $(this).waypoint({
                  handler: function(direction){

                    if (direction === 'down') {
                      $(this.element).addClass('motion');
                      //$(this.element).removeClass('none'); 

                    } 

                   }, 
                  offset: '90%'
                });

             });
            }
        }
        //contentScrollingEffect();

        function initContactForm() {

          $( 'div.wpcf7 > form' ).each( function() {
            console.log("initContactForm");
            var $form = $( this );
              wpcf7.initForm( $form );
            if ( wpcf7.cached ) {
              wpcf7.refill( $form );
            }
          });
        }
        initContactForm();

        function mobileMenu() {
          $('a#menu-more').click(function(e){
            e.preventDefault();
            $('#mobile_menu_nav').toggleClass('menu-up');
            $('.mobile_menu').slideToggle();
            
            if($('body').hasClass('fix')){
              $('body').removeClass('fix');
            } else {
              $('body').addClass('fix');  
            }

          });

          $('.close-btn').click(function(){
            $('#mobile_menu_nav').removeClass('menu-up');
            $('.mobile_menu').fadeOut();
            $('body').removeClass('fix');
          });

          if($( window ).width() >= 1200) {

            $('#mobile_menu_nav').removeClass('menu-up');
            $('.mobile_menu').hide();
            $('body').removeClass('fix');  

          }

          $(window).on('scroll', function(){
            if($(window).scrollTop() + $(window).height() > $(document).height() - 700) {
                //$('#mobile_menu_nav').fadeOut();
              } else {
                //$('#mobile_menu_nav').fadeIn();
              }
          });

        }
        //mobileMenu();

        function storyLine() {
          $('.story-line').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            //swipeToSlide: true,
            //draggable: true,
            //swipe: true,
            //touchMove: true,
            arrows: false,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ]
          });

          
          var totalSlides = $('.story').length - 1;

          $('.recent').click(function(e){
            e.preventDefault();
            $('.story-line').slick('slickGoTo', 0);
          });

          $('.beginning').click(function(e){
            e.preventDefault();

            $('.story-line').slick('slickGoTo', totalSlides);
          });

          $('.mouse-arrow.prev').click(function(e){
            e.preventDefault();
            $('.story-line').slick('slickPrev');
          });

          $('.mouse-arrow.next').click(function(e){
            e.preventDefault();
            $('.story-line').slick('slickNext');
          });

          function slide_index_condition() {
            
            // $('.story').each(function(){
            //   var slideIndex = $(this).data('slickIndex');

            //   if($(this).hasClass('slick-current') && slideIndex === 0) {

            //     $('.story-nav span.recent').addClass('active');
            //     $('.story-nav span.beginning').removeClass('active'); 
                   
            //   } else if ($(this).hasClass('slick-current') && slideIndex === totalSlides) {
            //       $('.story-nav span.beginning').addClass('active');
            //       $('.story-nav span.recent').removeClass('active');  
            //   } else if ($(this).hasClass('slick-current') && slideIndex !== 0 && slideIndex !== totalSlides) {
            //       $('.story-nav span').removeClass('active');
            //   } else {
              
            //   }
            // });

            $('.story').each(function(){
              if($(this).hasClass('slick-current')) {
                //alert(totalSlides);
                if($(this).attr('id') === 'story-1') {
                  
                  $('.story-nav span.recent').addClass('active');
                  $('.story-nav span.beginning').removeClass('active'); 

                  $('.mouse-arrow.prev').addClass('end');
                  $('.mouse-arrow.next').removeClass('end'); 

                } else if($(this).attr('id') === 'story-' + totalSlides) {

                  $('.story-nav span.recent').removeClass('active');
                  $('.story-nav span.beginning').addClass('active');  

                  $('.mouse-arrow.prev').removeClass('end');
                  $('.mouse-arrow.next').addClass('end'); 

                } else {
                  $('.story-nav span').removeClass('active');
                  $('.mouse-arrow').removeClass('end'); 
                }
              }
            });




          }
          slide_index_condition();

          $('.story-line').on('afterChange', function(event, slick, currentSlide, nextSlide){
            slide_index_condition();            
          });

          

        }
        //storyLine();
        
 
        function formInputEffect() {
          // JavaScript for label effects only
            //$(window).load(function(){

              
              $('.form-container input[type="text"], .form-container textarea').val("");
              
              $('.input-effect input').focusout(function(){
                if($(this).val() !== ""){
                  $(this).parent('span').addClass('has-content');
                  $(this).addClass("has-content");
                }else{
                  $(this).parent('span').removeClass('has-content');
                  //$(this).parent('span').removeClass('has-content');
                  $(this).removeClass("has-content");
                }
              });

              $('.text-effect textarea').focusout(function(){
                if($(this).val() !== ""){
                  $(this).parent('span').addClass('has-content');
                  $(this).addClass("has-content");
                }else{
                  $(this).parent('span').removeClass('has-content');
                  //$(this).parent('span').removeClass('has-content');
                  $(this).removeClass("has-content");
                }
              });
              


              $(".input-effect").on("click","input",function(){
                  if ($(this).is( ":focus" )) {
                      $(this).parent('span').addClass('focus');
                  } else {
                      $(this).parent('span').removeClass('focus');
                  }
              });

              $(".text-effect").on("click","textarea",function(){
                  if ($(this).is( ":focus" )) {
                      $(this).parent('span').addClass('focus');
                  } else {
                      $(this).parent('span').removeClass('focus');
                  }
              });

              $(".input-effect input").focusout(function(){
                  $(this).parent('span').removeClass('focus');
              });

              $(".text-effect textarea").focusout(function(){
                  $(this).parent('span').removeClass('focus');
              });

              // Tab button
              $('.input-effect input, .text-effect textarea').keyup(function () {
                    $(this).parent('span').addClass('focus');
              });
              
              
              // $(window).on('wpcf7:invalid', function() {
              //   alert('active');
              //     $('html,body').animate({scrollTop:$('.wpcf7-response-output').offset().top + 100}, 800); 
              // });

              // $(window).on('wpcf7:mailsent', function() {
              //   //console.log('active');
              //     $('html,body').animate({scrollTop:$('.wpcf7-response-output').offset().top + 100}, 800); 
              // });
              


              $('.wpcf7-form').ajaxComplete( function(){    
                if($(this).hasClass('invalid') || $(this).hasClass('sent')){
                  //alert('hello');
                  //$('html,body').animate({scrollTop:$('.wpcf7-response-output').offset().top - 500}, 1000); 
                  $('html,body').scrollTop( $(".wpcf7-response-output").offset().top - 500);
                }
              });



          
            //});
        }
        //formInputEffect();

        function postSlider() {

          var sliderOptions = {
              infinite: true,
              speed: 300,
              slidesToShow: 1,
              adaptiveHeight: true
          };

          if($('.post-slider').length) {
            $('.post-slider').slick(
              sliderOptions
            );
          }


          /*setTimeout(function() {
            var firstSlideHeight = $('.slick-current img').height();
            $('.slick-list').css('height',firstSlideHeight);
          }, 1000);*/

          
          $( ".slick-current img" ).load(function() {
            var firstSlideHeight = $('.slick-current img').height();
            $('.slick-list').css('height',firstSlideHeight);
          });

          
          //$('.post-slider').slick('unslick');

          $('.post-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.slider-index .current').empty();
            $('.slider-index .current').text(nextSlide + 1);
            // $(".slick-slide").removeClass('works');
            //   $('.slick-current').addClass('works');        
            });
        }
        //postSlider();

        function branchSelect() {

            $("#branchPicker").change(function(){
                var branchID = $('#branchPicker option:selected').attr('data-branch');
                $('.branch').each(function(){
                  $(this).removeClass('active');
                });
                $('#branch-' + branchID).addClass('active')  ;

                // $('.branch').fadeOut(function(){
                //   alert('go');
                  
                // });
                
            });

        }
        //branchSelect();



        function playVideo() {
          $(".playVideo").click(function(){
            var video_mp4 = $(this).data('video-mp4');
            var video_webm = $(this).data('video-webm');
            var video_ogv = $(this).data('video-ogv');
            var video_poster = $(this).data('video-poster');
            
            var video_box = '<video id="home-video" class="video-js vjs-default-skin" controls preload="auto" width="800" height="480" poster="" data-setup="{example_option:true}"> <source src="'+video_mp4+'" type="video/mp4" />';
            if(video_webm){
              video_box += ' <source src="'+video_webm+'" type="video/webm" />';
            }
            if(video_ogv){
              video_box += ' <source src="'+video_ogv+'" type="video/ogg" />';
            }
            video_box += ' </video>';
            
            /*var video_box = '<video width="100%" height="auto" preload="" controls="" poster="'+video_poster+'"><source type="video/mp4" src="'+video_mp4+'"></source><source type="video/webm" src="'+video_webm+'"></source><source type="video/ogg; codecs="theora, vorbis"" src="'+video_ogv+'"></source></video>';*/
            var myPlayer;
            
            $.fancybox({
              padding : 0,
              width : 800,
              height  : 480,
              autoSize: false,
              type  : "html",
              content   : video_box,
              beforeShow  : function(){
                // console.log('beforeshow video width: '+$('#example_video_1').outerWidth());
                // console.log('beforeshow video height: '+$('#example_video_1').outerHeight());
                
                $('.fancybox-inner').css({'display':'inline-flex', 'max-width':800, 'max-height':480});
                
              },
              afterShow: function() {
                // do this for the dynamically loaded video
                videojs('home-video').ready(function() {
                    //var myPlayer = this;
                    //this.play();
                    var is_iPad = navigator.userAgent.match(/iPad/i) != null;

                    if (!is_iPad) {
                      this.play();
                    }

                });
              },
              beforeClose: function() {
                // if you do not do this the video will keep downloading in the background
                videojs('home-video').dispose();
              }
            });
            
          });
        }
        //playVideo();

        function memberMobileCollapse() {        
            $('.memberList-mobile .member').each(function(){
              if($(this).hasClass('active')) {

                //$('html, body').animate({ scrollTop: $(".memberList-mobile .active").offset().top - 140},1000);

                $(this).find($('img.avatar')).addClass('zoom');
                $(this).find($('.pos')).addClass('show');
                $(this).find($('.member-bio')).slideDown(1000);
              }
            });
        }

        function memberMobileClose() {
          $('.memberList-mobile .member').each(function(){
            if($(this).hasClass('active')) {

              //$("html, body").stop().animate({scrollTop:0}, 500);

              $(this).find($('img.avatar')).removeClass('zoom');
              $(this).find($('.pos')).removeClass('show');
              $(this).find($('.member-bio')).slideUp(1000);
            }
          });
        }
        

        function scroll_sneak () {
           
           $(document).ready(function(){
            var sneaky = new ScrollSneak(location.hostname);
            $('.memberList-mobile a').each(function(){  
                    this.onclick = sneaky.sneak;
                });
            }); 
            
        }

         function page_reload_on_top () {
           if ($('#body-tag').is('.page-template-template-careers')) {  

            if(window.location.hash) {
              $(document).scrollTop( $("#jobs-list").offset().top );  
            } else {
              $(window).scrollTop(0);
            }

           } else if(!$('#body-tag').is('.team_member_register-template')) {

              $("html, body").scrollTop(0);  

           } else {

            $('html, body').animate({ scrollTop: $(".memberList-mobile .active").offset().top - 140},1000);

           }
        }


        /* =========================================================
        ============================================================
        Page Seemless effect
        ============================================================
        ========================================================= */

        
        

        //scrollCondition();

        function initPage(){
          //console.log('initPage');
          heroBanner();
          menuShrink();
          parentMenuActive();
          menuHighlight();
          mobileMenu();
          formInputEffect();
          page_reload_on_top();
          //scrollCondition();

          if (typeof page !== 'undefined') {
            switch(page){
              case 'story':
                storyLine();
                break;
              case 'contact':
                branchSelect();
                //initContactForm();
                break;
              case 'home':
                slider();
                playVideo();
                heroBanner();
                break;
              case 'management':
                //scroll_sneak();
                break;
              case 'profile':
                memberMobileCollapse();
                //page_reload_on_top();
                //scroll_sneak();
                break;
              case 'news-single':
                postSlider();
                break;
              case 'news':
                load_news_data();
                load_more_click();
                initCat();
                break;
              case 'careers':
                load_careers_data();
                set_dropdown_txt();
                initJobTypeSelection();
                initLocationSelection();
                page_reload_on_top();
                break;
            }
          }
        }
        initPage();
        //initContactForm();

        //alert(scroll_condition);

        function pageTrans() {
          $(function(){
            'use strict';

            var options = {
              debug: true,
              scroll: false,
              prefetch: false,
              blacklist: '.wpcf7-form, .playVideo, .memberList, .news-result-container, .job-list-container',
              cacheLength: 1,
              //scroll: true,
              onStart: {
                duration: 250, // Duration of our animation
                render: function ($container) {

                  // Add your CSS animation reversing class
                  $container.addClass('is-exiting');

                  // Restart your animation
                  smoothState.restartCSSAnimations();
                  
                  $('.hero-item, .page-template-default .header-banner').animate({
                     opacity: 0
                   }, 1000, function() {});

                  memberMobileClose(); 

                }
              },
              onReady: {
                duration: 0,
                render: function ($container, $newContent) {


                  // Remove your CSS animation reversing class
                  $container.removeClass('is-exiting');
   
                  // Inject the new content
                  $container.html($newContent);

                  //singlePostActive();

                  $('body').removeClass('fix');  

                   $('.hero-item, .page-template-default .header-banner').animate({
                     opacity: 1
                   }, 1000, function() {});



                }
              },
              onAfter: function($container, $newContent) {
                //console.log("onAfter");
                initPage();
                initContactForm();
              }
            },
            smoothState = $('#main').smoothState(options).data('smoothState');
          });
        }
        pageTrans();  
        
        
        // Resize
        $(window).resize(function() {
          if($('.hero, .header-banner, .header-banner-base').length) {
            heroBanner();
          }

          //parallaxEff();
          
          if($( window ).width() >= 1200) {

            $('#mobile_menu_nav').removeClass('menu-up');
            $('.mobile_menu').hide();
            $('body').removeClass('fix');  

          }
        }); 
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'page_template_template_our_story': {
      init: function() {
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'page_template_template_news': {
      init: function() {

      function searchBarHover() {
        $("input.search-bar").click(function(){
            $('.searchBar-line').addClass('active');
        });

        $('input.search-bar[type="text"]').val("");
                
        $('input.search-bar').focusout(function(){
          if($(this).val() !== ""){
            $('.searchBar-line').addClass('active');
          }else{
            $('.searchBar-line').removeClass('active');
          }
        });

        $("input.search-bar").on("click","input",function(){
            if ($(this).is( ":focus" )) {
                $('.searchBar-line').addClass('active');
            } else {
                $('.searchBar-line').removeClass('active');
            }
        });

        $("input.search-bar").focusout(function(){
            $('.searchBar-line').removeClass('active');
        });
      }

      searchBarHover();

      
  




      }
    },
    'page_template_template_careers': {
      init: function() {
      
      // Ajax load careers
      var jobType_var ='';
      var location_var ='';

      function career_getURLParameter(sParam){
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) 
        {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) 
            {
                return sParameterName[1];
            }
        }
      }

      function career_url_filter(){
       var type_url_filter = career_getURLParameter("type");
       var location_url_filter = career_getURLParameter("location");    
       
          if(typeof type_url_filter !== 'undefined'){

            jobType_var = type_url_filter;
            
          } else if (typeof location_url_filter !== 'undefined') { 
            
            location_var = location_url_filter;

          } else {

            jobType_var = '';
            location_var = '';
            
           }

      //$('html,body').animate({scrollTop: $('#jobs-result').offset().top - 600},'slow');

      }


      function load_careers_data(){
        career_url_filter();
        
        var ajaxurl = '/wp-admin/admin-ajax.php';

        //alert(jobType_var);
        
        // alert(jobType_filter);
        // location_filter = $('#selected-location').val();

        var data = {
          jobTypeData: jobType,
          locationData: jobLocation,
          lang: currentLang,
          action: "load-careers-data"
        };
        
        
        $.post(ajaxurl, data, function(response) {
          $response = $(response);

          $response.hide();
          $("#jobs-result").append($response);
          $response.fadeIn(500, function(){
            loading = false;
          });
          
          loading = false;
          
        });

      }
      //load_careers_data();


      // Set dropdown text
      function set_dropdown_txt(){
       
       jobType = career_getURLParameter("type");
       jobLocation = career_getURLParameter("location");
          
        if(typeof jobType !== 'undefined'){
          var selected_type_text = $('#job_type_selector a.dropdown-item[data-selected-type="' + jobType + '"]').text();
          $('#job_type_selector .dropdown-toggle span').text(selected_type_text);

          $('#location_selector .dropdown-toggle span').text('所有');

       } else if (typeof jobLocation !== 'undefined') {
          var selected_location_text = $('#location_selector a.dropdown-item[data-selected-location="' + jobLocation + '"]').text();
          $('#location_selector .dropdown-toggle span').text(selected_location_text);

          $('#job_type_selector .dropdown-toggle span').text('所有');
       }
    }
    //set_dropdown_txt();

      // Initialte the dropdown click
      function initJobTypeSelection(){
        
      $('#job_type_selector a.dropdown-item').each(function(){
        $(this).click(function(){
          
          jobLocation = '';

          jobType = $(this).data('selected-type');

          //URL config
          var url = full_url;
          
          if(jobType !== ''){
            url = url + '?type=' + jobType;
          }
          
          history.pushState('','', url);
          $("#jobs-result").html('');
          
          set_dropdown_txt();
          load_careers_data();

        }); 
      });

      }
      //initJobTypeSelection();

      function initLocationSelection(){

      $('#location_selector a.dropdown-item').each(function(){
        $(this).click(function(){

          jobType = '';
          
          jobLocation = $(this).data('selected-location');

          //URL config
          var url = full_url;
          
          if(jobLocation !== ''){
            url = url + '?location=' + jobLocation;
          }
          
          history.pushState('','', url);
          $("#jobs-result").html('');
          
          set_dropdown_txt();
          load_careers_data();

        }); 
      });

      }
      //initLocationSelection();




      }
    },

    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },

    'team_member_register_template': {
      init: function() {
        // JavaScript to be fired on the about us page

      }
    },

    'single_post': {
      init: function() {
        // JavaScript to be fired on the about us page

      },
      finalize: function() {
        
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      //$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
      $.each(document.getElementById('body-tag').className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.